import { toast } from 'react-toastify';

export const createLockRespondHandler =
  lockResponse =>
  async (responseId, isLocked = true) => {
    try {
      await lockResponse(responseId, isLocked);
      toast.success(isLocked ? 'Marked as agreed' : 'Agreement unlocked');
    } catch {
      toast.error(isLocked ? 'Failed to mark as agreed' : 'Failed to unlock');
    }
  };
